var map = {
	"./logo-alphabet.svg": 622,
	"./logo-amazon-2.svg": 623,
	"./logo-amazon.svg": 713,
	"./logo-azercell.svg": 714,
	"./logo-bank-of-america.svg": 715,
	"./logo-barclays.svg": 716,
	"./logo-bbc.svg": 717,
	"./logo-bloomberg.svg": 624,
	"./logo-bnp-paribas.svg": 718,
	"./logo-booking.svg": 719,
	"./logo-citibank.svg": 720,
	"./logo-cnbc.svg": 625,
	"./logo-cnbc2.svg": 721,
	"./logo-coca-cola-auto.svg": 621,
	"./logo-coca-cola-white.svg": 1644,
	"./logo-coca-cola.svg": 722,
	"./logo-deloitte.svg": 723,
	"./logo-experian.svg": 724,
	"./logo-facebook.svg": 725,
	"./logo-forbes.svg": 626,
	"./logo-g.svg": 1645,
	"./logo-goldman-sachs-new.svg": 726,
	"./logo-goldman-sachs.svg": 1489,
	"./logo-google-new.svg": 727,
	"./logo-google.svg": 728,
	"./logo-h.svg": 729,
	"./logo-henkel.svg": 730,
	"./logo-hsbc-new.svg": 731,
	"./logo-hsbc.svg": 1487,
	"./logo-ikea-new.svg": 732,
	"./logo-ikea.svg": 1646,
	"./logo-infineon.svg": 733,
	"./logo-instagram-icon.svg": 619,
	"./logo-instagram.svg": 734,
	"./logo-jp-morgan.svg": 735,
	"./logo-jti.svg": 736,
	"./logo-linkedin.svg": 737,
	"./logo-meta-new.svg": 618,
	"./logo-meta.svg": 1490,
	"./logo-morgan-stanley-new.svg": 738,
	"./logo-morgan-stanley.svg": 1488,
	"./logo-netflix.svg": 1485,
	"./logo-oracle.svg": 627,
	"./logo-paypal.svg": 739,
	"./logo-pwc-new.svg": 620,
	"./logo-pwc.svg": 1647,
	"./logo-spotify.svg": 1486,
	"./logo-tesla.svg": 740,
	"./logo-usa-today.svg": 628,
	"./logo-visa.svg": 741,
	"./logo-walmart.svg": 629,
	"./logo-wsj.svg": 630,
	"./logo-youtube.svg": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1236;